module.exports = __webpack_public_path__ + "static/Scheme-Payouts-EN-0914828c3faf88dda15a541714a82eee.svg";